import React, {Component} from 'react';
import CommunityPage from './CommunityPage';
import './CommunityProfilePage.css';
import actions from './community.actions';
import {connect} from 'react-redux';
import {DocumentTitle, OptionsButton, Spinner, PrimaryButton} from '../widgets';
import CommunitySidePane from './CommunitySidePane';
import {
	canAdmin,
	getSessionUserMembership,
	getParamsUniqueName,
	getProfileUniqueName
} from './community.selectors';
import {uiActions} from '../chrome';
import Dropzone from 'react-dropzone';
import userHasBaseDetails from '../user/userHasBaseDetails';

class CommunityProfilePage extends CommunityPage {
	constructor(props) {
		super(props);

		const paramUniqueName = getParamsUniqueName(props);
		if (paramUniqueName && (!props.community || getProfileUniqueName(props) !== paramUniqueName)) {
			props.retrieveCommunity(paramUniqueName);
		}
	}

	render() {
		if (!this.props || !this.props.community || !this.props.community.profile) {
			return (
				<DocumentTitle title="B2Me">
					<main className="CommunityProfilePage">
						<Spinner />
					</main>
				</DocumentTitle>
			);
		}

		const {
			community: {
				name,
				profile: {brief, about, images}
			},
			sessionProvider,
			joinCommunity,
			editContacts,
			persistBackgroundImage,
			deleteImage,
			moveImage,
			dropProfileFile,
			dragOverAddImage,
			dragOutAddImage,
			draggingOverProfileImage,
			addingProfileImage
		} = this.props;

		const editable = canAdmin(this.props); // OR global admin
		const sessionUserMembership = getSessionUserMembership(this.props);

		return (
			<DocumentTitle title={`${this.props.community.name} - B2Me`}>
				<main className="CommunityProfilePage">
					{joinCommunity && userHasBaseDetails(sessionProvider) && !sessionUserMembership && (
						<PrimaryButton onClick={joinCommunity} icon="person_add">
							Join this community
						</PrimaryButton>
					)}

					<CommunitySidePane
						community={this.props.community}
						sessionProvider={sessionProvider}
						joinCommunity={joinCommunity}
						editContacts={editContacts}
					/>

					<section className="CommunityProfilePage-details">
						<article className="CommunityProfilePage-profile-summary">
							<div className="CommunityProfilePage-brief">
								<p>{brief}</p>
							</div>
						</article>

						{images && (
							<article className={`CommunityProfilePage-photos ${!images.length ? 'empty' : ''}`}>
								<ol>
									{editable && (
										<li className="CommunityProfilePage-photos-add">
											<Dropzone
												className={`CommunityProfilePage-photos-dropzone ${
													draggingOverProfileImage ? 'over' : ''
												} ${addingProfileImage ? 'adding' : ''}`}
												onDrop={dropProfileFile}
												accept="image/jpeg, image/png"
												onDragEnter={dragOverAddImage}
												onDragLeave={dragOutAddImage}
												disabled={!editable}>
												{addingProfileImage && <Spinner />}
												{!addingProfileImage && (
													<button>
														<span className="icon icon-add_a_photo" />
														<span className="CommunityProfilePage-photos-label">Add photo</span>
													</button>
												)}
											</Dropzone>
										</li>
									)}
									{images
										.sort((a, b) => b.priority - a.priority)
										.map((image, idx) => (
											<li key={image} style={{backgroundImage: `url("/api/image/${image.image}")`}}>
												{editable && (
													<OptionsButton
														className="CommunityProfilePage-photo-options"
														options={[
															{
																key: 'delete',
																icon: 'icon-delete',
																label: 'Remove this photo',
																onSelect: () => deleteImage(image.image)
															},
															{
																key: 'header',
																icon: 'icon-photo',
																label: 'Set as header',
																onSelect: () => persistBackgroundImage(image.image)
															},
															idx !== 0
																? {
																		key: 'forward',
																		icon: 'icon-arrow_back',
																		label: 'Move Forward',
																		onSelect: () => moveImage(image.image, true)
																  }
																: undefined,
															idx < images.length - 1
																? {
																		key: 'backward',
																		icon: 'icon-arrow_forward',
																		label: 'Move Backward',
																		onSelect: () => moveImage(image.image, false)
																  }
																: undefined
														]}
													/>
												)}
											</li>
										))}
								</ol>
							</article>
						)}

						<article className="CommunityProfilePage-profile-about">
							<div className="CommunityProfilePage-header">
								<h2>About {name}</h2>
							</div>
							<div className="CommunityProfilePage-prose">{about}</div>
						</article>
					</section>
				</main>
			</DocumentTitle>
		);
	}
}

const ConnectedCommunityProfilePage = connect(
	({community, session}) => ({
		community,
		sessionProvider: session && session.current
	}),
	dispatch => ({
		retrieveCommunity: uniqueName => dispatch(actions.retrieveCommunity(uniqueName)),
		joinCommunity: uniqueName => dispatch(actions.joinCommunity()),
		editContacts: () => {
			dispatch(actions.communityEditContacts());
			dispatch(uiActions.uiModal('community-edit-contacts'));
		},
		persistBackgroundImage: value => dispatch(actions.persistBackgroundImage(value)),
		deleteImage: value => dispatch(actions.deleteImage(value)),
		moveImage: (image, forward) => dispatch(actions.moveImage(image, forward)),
		dropProfileFile: acceptedFiles =>
			acceptedFiles[0] && dispatch(actions.uploadProfileImage(acceptedFiles[0])),
		dragOverAddImage: () => dispatch(actions.communityDragOverProfileImage()),
		dragOutAddImage: () => dispatch(actions.communityDragOutProfileImage())
	})
)(CommunityProfilePage);

export default ConnectedCommunityProfilePage;



// WEBPACK FOOTER //
// ./src/community/CommunityProfilePage.js